import { Country, City } from 'country-state-city';

export const COUNTRIES = Country.getAllCountries().map(c => c.name);

export function getCitiesForCountry(countryName) {
  if (!countryName) return [];
  const country = Country.getAllCountries().find(c => c.name === countryName);
  if (!country) return [];
  return City.getCitiesOfCountry(country.isoCode).map(c => c.name);
}
